import axios, { AxiosError, AxiosInstance } from 'axios';
import { useMutation, UseMutationResult } from 'react-query';
import { getBuildStageEndPoint } from '../utils/axiosFetch';

export const useSendBSPSupportRequest = (
  c1Token: string,
  userRegion: string
): UseMutationResult<
  BSPSupportRequestSuccess,
  { message: string; status: number },
  BSPSupportRequestData,
  BSPSupportRequestSuccess
> =>
  useMutation(async (bspSupportRequestData: BSPSupportRequestData) => {
    const API_SUPPORT = axios.create({ baseURL: getBuildStageEndPoint('support.' + userRegion) });
    API_SUPPORT.interceptors.response.use(
      (response) => response,
      ({ response, request, message }: AxiosError<BSPSupportRequestError>) => {
        return Promise.reject({
          message: `${response?.data?.message || message || request}`,
          status: response?.status as number,
        });
      }
    );

    const { data }: { data: BSPSupportRequestSuccess } = await API_SUPPORT.post(
      '/bsp-contacts',
      bspSupportRequestData,
      {
        headers: {
          'api-version': 'v1',
          Accept: 'application/json',
          Authorization: `Bearer ${c1Token}`,
        },
      }
    );

    return data;
  });
